import {
	Dialog,
	DialogTitle,
	Typography,
	Button,
	DialogActions,
	DialogContent,
} from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useCentralStore } from "../../../../../dentlab/src/store/Central";
import { getClientDisplayName } from "@/lib/utils/client-utils";

export const UnshareDialog: React.FC<{
	shared: boolean;
	entityName: string | null;
	onUnshare: () => void;
	open: boolean;
	onClose: () => void;
}> = ({ shared, entityName, onUnshare, open, onClose }) => {
	const { client } = useCentralStore((state) => ({
		client: state.client,
	}));

	if (!shared) return null;

	return (
		<Dialog open={open} onClose={onClose}>
			<div
				style={{
					position: "relative",
					width: "30rem",
					height: "fit-content",
					minHeight: "15rem",
				}}
			>
				<div
					style={{
						height: "3rem",
						backgroundColor: "#d32f2f",
						position: "relative",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
						minHeight: "6rem",
						paddingTop: "1rem",
						paddingBottom: "1rem",
					}}
				>
					<Typography variant="h6" color="white">
						Freigabe aufheben für {getClientDisplayName(client)}
					</Typography>
				</div>
				<DialogContent
					style={{
						display: "flex",
						flexDirection: "column",
						paddingBottom: "3rem",
						paddingTop: "1rem",
					}}
				>
					<Typography variant="body1">
						Möchten Sie die Freigabe für{" "}
						<strong>{entityName}</strong> wirklich aufheben?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={onClose}
						sx={{
							position: "absolute",
							left: "1rem",
							bottom: "1rem",
						}}
					>
						Abbrechen
					</Button>
					<Button
						onClick={() => {
							onUnshare();
							onClose();
						}}
						color="error"
						sx={{
							position: "absolute",
							right: "1rem",
							bottom: "1rem",
						}}
					>
						Freigabe aufheben
					</Button>
				</DialogActions>
			</div>
		</Dialog>
	);
};
